import {tipiDocumento} from "../../../../../utils/arrays/Generics";

export function resetAnagrafica(anagrafica) {
	return {
		...anagrafica,
		comuneNascita: getComuneNascita(anagrafica.comuneNascita),
		domASL: anagrafica.domASL ? getAslCode(anagrafica.domASL) : "301",
		resASL: anagrafica.resASL ? getAslCode(anagrafica.resASL) : "301",
		tipoDocumento: anagrafica.codF ? tipiDocumento[0].val
			: anagrafica.cartaIdentita ? tipiDocumento[0].val :
				anagrafica.patente ? tipiDocumento[1].val :
					anagrafica.passaporto ? tipiDocumento[2].val : tipiDocumento[3].val
	}
}

function getComuneNascita(comune) {
	let comuneString = "";
	if (comune && comune.split(",").length > 3) {
		comuneString = comune.split(",")[2]?.replace(" ", "") + ", " + comune.split(",")[3]
	}
	return comuneString;
}

function getAslCode(asl) {
	if (asl === "A.S.L. CITTA' DI TORINO") {
		return "301";
	} else if (asl.includes("CUNEO 1")) {
		return "210"
	} else if (asl.includes("CUNEO 2")) {
		return "211"
	} else {
		return "301"
	}
}

export function resetIntervista(intervista) {
	console.log(intervista);
	let sintomiIntervista = {};
	if (intervista.listaSintomi && intervista.listaSintomi.split(",").length > 0) {
		intervista.listaSintomi.split(",").forEach(item => {
			sintomiIntervista = {
				...sintomiIntervista,
				[item.replace(/[\W_]+/g, "_")]: true,
			}
		})
	}
	
	let immunodepressioniIntervista = {};
	if (intervista.listaImmunodepressioni && intervista.listaImmunodepressioni.split(",").length > 0) {
		intervista.listaImmunodepressioni.split(",").forEach(item => {
			immunodepressioniIntervista = {
				...immunodepressioniIntervista,
				[item.replace(/[\W_]+/g, "_")]: true,
			}
		})
	}
	
	let patologieIntervista = {};
	if (intervista.listaPatologieCroniche && intervista.listaPatologieCroniche.split(",").length > 0) {
		intervista.listaPatologieCroniche.split(",").forEach(item => {
			patologieIntervista = {
				...patologieIntervista,
				[item.replace(/[\W_]+/g, "_")]: true,
			}
		})
	}
	
	let rischiIntervista = {};
	if (intervista.listaEspRischio && intervista.listaEspRischio.split(",").length > 0) {
		intervista.listaEspRischio.split(",").forEach(item => {
			rischiIntervista = {
				...rischiIntervista,
				[item.replace(/[\W_]+/g, "_")]: true,
			}
		})
	}
	
	let parametriIntervista = {};
	if (intervista.parametriIsolamento && intervista.parametriIsolamento.split(",").length > 0) {
		intervista.parametriIsolamento.split(",").forEach(item => {
			parametriIntervista = {
				...parametriIntervista,
				[item.replace(/[\W_]+/g, "_")]: true,
			}
		})
	}
	
	return {
		...intervista,
		...sintomiIntervista,
		...immunodepressioniIntervista,
		...patologieIntervista,
		...rischiIntervista,
		...parametriIntervista,
		appartieneComunita: intervista.appartieneComunita ? "true" : "false",
		presentaSintomi: intervista.presentaSintomi ? "true" : "false",
		immunodepresso: intervista.immunodepresso ? "true" : "false",
		patologieCroniche: intervista.patologieCroniche ? "true" : "false",
		scaricataAppImmuni: intervista.scaricataAppImmuni ? "true" : "false",
		viaggiato14gg: intervista.viaggiato14gg ? "true" : "false",
		regioni14gg: intervista.regioni14gg ? "true" : "false",
		viviDaSolo: intervista.viviDaSolo ? "true" : "false",
		correttoIsolamento: intervista.correttoIsolamento ? "true" : "false",
		possibileEspRischio: intervista.possibileEspRischio ? "true" : "false",
		ricoverato: intervista.ricoverato ? "true" : "false",
		paesiEsteri: intervista.paesiEsteri?.split(",").filter(i => i !== ""),
		regioniVisitate: intervista.regioniVisitate?.split(",").filter(i => i !== ""),
	}
}
